export function isLocalIntegrationDemo(location = window.location) {
  return process.env.NODE_ENV !== 'production'
    && ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname);
}
